/* ---------------------------------
Emphasized
--------------------------------- */

export default function Emphasized({ children }) {
  return <span className={'Emphasized'}>{children}</span>
}
